module.exports = __webpack_public_path__ + "static/img/photo.0d64bd15.png";